var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8606 5.39385L18.3814 1.19465C17.8981 0.741557 17.1071 1.08424 17.1071 1.74672C17.1071 2.16465 16.7683 2.50345 16.3504 2.50345H1.83472C1.28243 2.50345 0.834717 2.95116 0.834717 3.50345V5.25862C0.834717 5.81091 1.28243 6.25862 1.83472 6.25862H22.5186C22.9719 6.25862 23.1913 5.70386 22.8606 5.39385Z",
    fill: "#0D90F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.922384 9.20942L5.40153 13.4086C5.88483 13.8617 6.67583 13.519 6.67583 12.8566C6.67583 12.4386 7.01463 12.0998 7.43256 12.0998H21.9482C22.5005 12.0998 22.9482 11.6521 22.9482 11.0998V9.34465C22.9482 8.79237 22.5005 8.34465 21.9482 8.34465H1.26435C0.811085 8.34465 0.591707 8.89941 0.922384 9.20942Z",
    fill: "#0D90F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2002 25.1432V26.3042L15.2991 29.2068L7.51058 26.9544V28.6263H0.834717V15.8551H9.70249L16.5564 18.5254C17.8025 19.013 18.637 20.2669 18.637 21.6602H20.8623C22.7093 21.6602 24.2002 23.2159 24.2002 25.1432ZM5.28529 26.3042V18.1771H3.06V26.3042H5.28529ZM21.8637 24.644C21.6857 24.2609 21.2962 23.9938 20.8623 23.9938H14.9097C14.3088 23.9938 13.7191 23.8893 13.1517 23.692L10.5036 22.7747L11.2046 20.5688L13.8526 21.486C14.1976 21.6021 16.4117 21.6602 16.4117 21.6602C16.4117 21.2306 16.1558 20.8475 15.7775 20.6965L9.30193 18.1771H7.51058V24.5395L15.2657 26.7803L21.8637 24.644Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutColor);
export default __webpack_public_path__ + "static/media/sign-out-color.39d9ed5cc10e77e8a72ddb608b1b7361.svg";
export { ForwardRef as ReactComponent };